// extracted by mini-css-extract-plugin
module.exports = {"image":"svg-image_image__2jP6B","loaded":"svg-image_loaded__8A_Oy","cached":"svg-image_cached__3O7vp"};